/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { urlControllerGoogleDeleteUrlV1 } from '../fn/url/url-controller-google-delete-url-v-1';
import { UrlControllerGoogleDeleteUrlV1$Params } from '../fn/url/url-controller-google-delete-url-v-1';

@Injectable({ providedIn: 'root' })
export class UrlService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `urlControllerGoogleDeleteUrlV1()` */
  static readonly UrlControllerGoogleDeleteUrlV1Path = '/api/v1/url/delete-user';

  /**
   * 구글 테스트.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `urlControllerGoogleDeleteUrlV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  urlControllerGoogleDeleteUrlV1$Response(params?: UrlControllerGoogleDeleteUrlV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return urlControllerGoogleDeleteUrlV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 구글 테스트.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `urlControllerGoogleDeleteUrlV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  urlControllerGoogleDeleteUrlV1(params?: UrlControllerGoogleDeleteUrlV1$Params, context?: HttpContext): Observable<void> {
    return this.urlControllerGoogleDeleteUrlV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
